import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { InfoIconWithPopover } from "../../../../components/Title/InfoIconWithPopover";

export function CompanyCardDescriptionIndependentBookings() {
  const { t } = useTranslation();

  return (
    <InfoIconWithPopover title={t("_companyCard_independentBookings")}>
      <Box sx={{ p: 1, maxWidth: 640 }}>
        <Typography variant="body1" color="text.secondary">
          {t("_companyCard_independentBookings_intro")}
        </Typography>
      </Box>
    </InfoIconWithPopover>
  );
}
